import { render, staticRenderFns } from "./SlidersImageVideo.vue?vue&type=template&id=55c5fe7e"
import script from "./SlidersImageVideo.vue?vue&type=script&lang=js"
export * from "./SlidersImageVideo.vue?vue&type=script&lang=js"
import style0 from "./SlidersImageVideo.vue?vue&type=style&index=0&id=55c5fe7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports